import { render, staticRenderFns } from "./QrPromptpay.vue?vue&type=template&id=3946f5b8&"
import script from "./QrPromptpay.vue?vue&type=script&lang=js&"
export * from "./QrPromptpay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports